var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { BgColorDirective } from './bg-color/bg-color';
import { BtnColorDirective } from './btn-color/btn-color';
import { TextColorDirective } from './text-color/text-color';
import { HeaderBgColorDirective } from './header-bg-color/header-bg-color';
import { FooterBgColorDirective } from './footer-bg-color/footer-bg-color';
import { HeaderTextColorDirective } from './header-text-color/header-text-color';
import { FooterTextColorDirective } from './footer-text-color/footer-text-color';
var DirectivesModule = /** @class */ (function () {
    function DirectivesModule() {
    }
    DirectivesModule = __decorate([
        NgModule({
            declarations: [BgColorDirective,
                BtnColorDirective,
                TextColorDirective,
                HeaderBgColorDirective,
                FooterBgColorDirective,
                HeaderTextColorDirective,
                FooterTextColorDirective],
            imports: [],
            exports: [BgColorDirective,
                BtnColorDirective,
                TextColorDirective,
                HeaderBgColorDirective,
                FooterBgColorDirective,
                HeaderTextColorDirective,
                FooterTextColorDirective]
        })
    ], DirectivesModule);
    return DirectivesModule;
}());
export { DirectivesModule };
//# sourceMappingURL=directives.module.js.map


// WEBPACK FOOTER //
// ./src/directives/directives.module.ts.pre-build-optimizer.js